import { mapActions } from 'vuex'
import IcaAddSingleRecipeToFolderModal from "@/vue/components/molecules/AddSingleRecipeToFolderModal.vue"

export default {
  components: {
    IcaAddSingleRecipeToFolderModal
  },
  data () {
    return {
      activeRecipeId: null,
      activeRecipeTitle: '',
      showFolderModal: false,
    }
  },
  methods: {
    ...mapActions(['getPublicAccessToken']),
    openFolderModal ({ id, title }) {
      if (this.$root.isLoggedIn) {
        this.activeRecipeId = id
        this.activeRecipeTitle = title
        this.showFolderModal = true
      } else {
        this.$ICALogin.forceUserLogin(this.$root.envConfig.loginEndpointUrl)
      }
    },
    closeModal () {
      this.showFolderModal = false
    },
    saveToFolder () {
      this.showFolderModal = false
    },
  },
}
